(ns app.front.view.group.admin.property.config.unit-designators
  (:require [app.domain.property.model :as property-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.tag-type-editor :as ui-tag-type-editor]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.comm :as comm]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(defn- unit-designator-item [entity lang]
  {:alphabet (-> entity (property-model/unit-designator-name lang) (or "") str/upper-case first)
   :name     (-> entity :property-unit-designator/names i18n-model/strings-map)
   :id       (:db/id entity)
   :active?  (du/in-state? :property-unit-designator.state/active entity)})

(rf/reg-sub ::unit-designator-items
  :<- [::entities/entities {:entity/type :entity.type/property-unit-designator}]
  (fn [unit-designators [_ group-id lang]]
    (->> unit-designators
         (filter #(= (-> % :property-unit-designator/group :db/id) group-id))
         (sort-by #(property-model/unit-designator-name % lang))
         (map #(unit-designator-item % lang)))))

(rf/reg-sub ::unit-designators-in-use
  :<- [::gas/config-defaults]
  #(:unit-designators-in-use % #{}))

(rf/reg-event-fx ::store-new-unit-designator
  (fn [{:keys [db]} [_ group-id {:keys [names on-done]}]]
    {:db           (update db ::creating-designator #(conj (or % #{}) group-id))
     :comm/command {:command    :group/add-property-unit-designator
                    :method     :post
                    :data       (util/mmap group-id names)
                    :on-success [::store-new-designator.success group-id on-done]
                    :on-done    [::store-new-designator.done group-id]}}))

(rf/reg-event-fx ::store-new-designator.done
  (fn [{:keys [db]} [_ group-id status body request-id]]
    {:db       (-> db
                   (update ::creating-designator #(disj % group-id)))
     :dispatch (when (>= status 400)
                 (comm/error-notification-evt status body request-id))}))

(rf/reg-event-fx ::store-new-designator.success
  (fn [{:keys [db]} [_ group-id on-done status response]]
    (on-done)
    {:db         (-> db
                     (update ::creating-designator #(disj % group-id)))
     :dispatch-n [[::entities/apply-changes status response]
                  [:notifications/add :toast :success :success :unit-designator-editor/add-success]]}))

(rf/reg-event-fx ::remove-unit-designator
  (fn [_ [_ id]]
    {:comm/command {:command    :group/remove-property-unit-designator
                    :method     :post
                    :data       {:id id}
                    :on-success [::remove-designator.success]}}))

(rf/reg-event-fx ::remove-designator.success
  (fn [_ [_ status response]]
    {:dispatch-n [[::entities/apply-changes status response]
                  [:notifications/add :toast :success :success :unit-designator-editor/remove-success]]}))

(rf/reg-event-fx ::update-command
  (fn [_ [_ id value language]]
    {:comm/command {:command    :group/rename-property-unit-designator
                    :method     :post
                    :data       {:id       id
                                 :language language
                                 :name     value}
                    :on-success [::update-designator.success]}}))

(rf/reg-event-fx ::update-designator.success
  (fn [_ [_ status response]]
    (prn response)
    {:dispatch-n [[::entities/merge-entity-db status response]
                  [:notifications/add :toast :success :success :unit-designator-editor/update-success]]}))

(rf/reg-event-fx ::set-unit-designator-active
  (fn [_ [_ active? id]]
    {:comm/command {:command    :group/set-unit-designator-active
                    :method     :post
                    :data       (util/mmap id active?)
                    :on-success [::set-active.success]}}))

(rf/reg-event-fx ::set-active.success
  (fn [_ [_ status response]]
    (prn response)
    {:dispatch-n [[::entities/apply-changes status response]
                  [:notifications/add :toast :success :success :unit-designator-editor/update-success]]}))

(rf/reg-event-fx ::end-edit-unit-designator
  (fn [_ [_ id language {:keys [name]}]]
    (let [name (get name language)]
      {:dispatch [::update-command id name language]})))

(rf/reg-sub ::creating-designator
  (fn [db _]
    (::creating-designator db #{})))

(rf/reg-sub ::create-designator-in-progress?
  :<- [::creating-designator]
  (fn [creating [_ config-id]] (contains? creating config-id)))


(defn- unit-designator-editor [tr]
  (let [group-id             (<sub [::gas/group-id])
        language             (<sub [::ui-i18n/editor-language ::gas/allowed-locales])
        unit-designators     (<sub [::unit-designator-items group-id language])
        selected-designators (->> unit-designators
                                  (filter :active?)
                                  (map :id)
                                  set)]
    [:<>
     [ui-tag-type-editor/editor
      (util/mmap {:values              unit-designators
                  :selected?           #(contains? selected-designators (:id %))
                  :on-end-edit         (fn [{:keys [id name] :as item}]
                                         (let [language (ui-i18n/get-actual-language-to-edit name language)]
                                           (>evt [::end-edit-unit-designator id language item])))
                  :edit-disabled?      (comp (<sub [::unit-designators-in-use]) :id)
                  :group-by-fn         (when (> (count unit-designators) 5) :alphabet)
                  :name-attr           :name
                  :on-create           #(>evt [::store-new-unit-designator
                                               group-id
                                               %])
                  :on-delete           #(>evt [::remove-unit-designator (:id %)])
                  :on-toggle           (fn [checked? {:keys [id]}]
                                         (>evt [::set-unit-designator-active checked? id]))
                  :create-in-progress? (<sub [::create-designator-in-progress? group-id])
                  :tag-type-name       (tr [:unit-designator-editor/unit-designator])
                  :remove-confirmation (tr [:unit-designator-editor/remove-confirmation])}
                 tr)]]))

(defn view []
  (let [tr (<sub [::gas/group-tr])]
    [acommon/config-section
     (tr [:property-mgmt-config/unit-designators-title])
     [:p.admin-page__instruction.bx--col-bx-12.whitespace-pre-line (tr [:property-mgmt-config/unit-designators-instruction])]
     [acommon/admin-config-form
      [unit-designator-editor tr]]]))
